import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  padding: 24px;
  z-index: 1000;
`;

const Card = styled.section`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12);
  max-width: 480px;
  width: 100%;
  overflow: hidden;
`;

const Header = styled.header`
  background: #ce0e2d;
  color: #ffffff;
  padding: 16px 22px;
  font-weight: 700;
  font-size: 1.05em;
`;

const Body = styled.div`
  padding: 22px 24px 18px;
  text-align: center;
`;

const Title = styled.h2`
  margin: 0 0 10px;
  font-size: 1.15em;
  color: #1f2937;
`;

const Message = styled.p`
  margin: 0 0 4px;
  color: #374151;
  line-height: 1.55;
  font-size: 0.95em;
`;

const ButtonRow = styled.div`
  padding: 14px 24px 22px;
  display: flex;
  justify-content: center;
`;

const SignInButton = styled.button`
  background: #ce0e2d;
  color: #ffffff;
  border: none;
  border-radius: 4px;
  padding: 10px 28px;
  font-size: 0.95em;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;

  &:hover {
    background: #a30b24;
  }

  &:focus-visible {
    outline: 2px solid #1f2937;
    outline-offset: 2px;
  }
`;

const SignedOutSplash = ({ onSignIn }) => (
  <Backdrop role="dialog" aria-modal="true" aria-labelledby="signed-out-title">
    <Card>
      <Header>Signed out</Header>
      <Body>
        <Title id="signed-out-title">You&apos;ve been signed out</Title>
        <Message>
          Your session has expired and you&apos;ve been signed out for security.
          Please sign in again to continue.
        </Message>
      </Body>
      <ButtonRow>
        <SignInButton type="button" onClick={onSignIn} autoFocus>
          Sign in
        </SignInButton>
      </ButtonRow>
    </Card>
  </Backdrop>
);

SignedOutSplash.propTypes = {
  onSignIn: PropTypes.func.isRequired,
};

export default SignedOutSplash;
